import { render, staticRenderFns } from "./PrestaEditor.vue?vue&type=template&id=28357b69"
import script from "./PrestaEditor.vue?vue&type=script&lang=js"
export * from "./PrestaEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports